<template>
  <div>
    <v-container class="padding_10" fluid grid-list-md>
      <v-layout row wrap style="padding: 0px 0px 0px 0px; align-content: center; align-items: center;">
        <v-flex xm12 sm12 md12 lg12 style="flex-wrap: wrap; display:flex; justify-content: flex-end;">
          <v-flex xm12 sm12 md12 lg6></v-flex>
          <v-flex xm12 sm12 md12 lg6 style="justify-content: flex-end;display: flex; flex-wrap: wrap;">
            <v-flex xm12 sm12 md6 lg6>
              <v-btn color="info" @click="updateAdNetworkDialog = true">Update Ad Network</v-btn>
            </v-flex>
            <v-flex xm12 sm12 md6 lg6>
              <v-btn color="info" @click="addNewAdScheduleDialog = true">Add New Schedule</v-btn>
            </v-flex>
          </v-flex>

        </v-flex>

        <v-flex xm12 sm12 md12 lg12>
          <v-data-table
              :headers="headers"
              :items="adData"
              class="elevation-1"
              item-key="id"
              :loading="adScheduleLoading"
              :total-items="total_items"
              :rows-per-page-items="[10, 20, 50, 100]"

          >
            <template v-slot:items="props">
              <td>{{ props.item.slot_name }}</td>
              <!--            v-if="!isEditingRow(props.item.id)"-->
              <!--            <td v-else>-->
              <!--              <v-autocomplete-->
              <!--                  v-model="props.item.slot_name"-->
              <!--                  :items="slot_details"-->
              <!--                  item-value="slot_name"-->
              <!--                  item-text="slot_name"-->
              <!--                  return-object solo flat-->
              <!--              ></v-autocomplete>-->
              <!--            </td>-->

              <td>{{ props.item.screen_location }}</td>
              <!--            v-if="!isEditingRow(props.item.id)"-->
              <!--            <td v-else>-->
              <!--              <v-autocomplete-->
              <!--                  v-model="props.item.screen_location"-->
              <!--                  :items="slot_details"-->
              <!--                  item-value="screen_location"-->
              <!--                  item-text="screen_location"-->
              <!--                  return-object solo flat-->
              <!--              ></v-autocomplete>-->
              <!--            </td>-->

              <td>{{ props.item.network_name }}</td>
              <!--            v-if="!isEditingRow(props.item.id)"-->
              <!--            <td v-else>-->
              <!--              <v-autocomplete-->
              <!--                  v-model="props.item.network_name"-->
              <!--                  :items="network_provider"-->
              <!--                  item-value="name"-->
              <!--                  item-text="name"-->
              <!--                  return-object-->
              <!--                  solo flat-->
              <!--              ></v-autocomplete>-->
              <!--            </td>-->

              <td>{{ props.item.is_active ? 'Active' : 'Inactive' }}</td>

              <td v-if="!isEditingRow(props.item.id)">{{ props.item.start_time }}</td>
              <td v-else>
                <v-text-field v-model="props.item.start_time" dense hide-details></v-text-field>
              </td>

              <td v-if="!isEditingRow(props.item.id)">{{ props.item.end_time }}</td>
              <td v-else>
                <v-text-field v-model="props.item.end_time" dense hide-details></v-text-field>
              </td>

              <td>
                <template v-if="isEditingRow(props.item.id)">
                  <v-btn icon text small @click="saveRow(props.item)">
                    <v-icon class="material-icons" color="green">check</v-icon>
                  </v-btn>

                  <v-btn icon text small @click="cancelEdit(props.item.id)">
                    <v-icon class="material-icons" color="red">close</v-icon>
                  </v-btn>
                </template>
                <template v-else>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" icon text small @click="startEdit(props.item.id)">
                        <v-icon class="material-icons" color="blue">edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit Ad Schedule</span>
                  </v-tooltip>

                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn text icon small v-bind="attrs" v-on="on"
                             @click="deleteScheduleDialog = !deleteScheduleDialog;
                     ad_schedule_id = props.item.id;">
                        <v-icon class="material-icons" color="red">delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete Ad Schedule</span>
                  </v-tooltip>
                </template>
              </td>
            </template>
          </v-data-table>

          <!--        <v-data-table-->
          <!--            :headers="headers"-->
          <!--            :items="adData"-->
          <!--            class="elevation-1"-->
          <!--        >-->
          <!--          <template v-slot:items="props">-->
          <!--            <td>{{ props.item.slot_name }}</td>-->
          <!--            <td>{{ props.item.screen_location }}</td>-->
          <!--            <td>{{ props.item.network_name }}</td>-->
          <!--            <td>{{ props.item.is_active }}</td>-->
          <!--            <td>{{ props.item.start_time }}</td>-->
          <!--            <td>{{ props.item.end_time }}</td>-->
          <!--            <td>-->
          <!--              <v-tooltip left><template v-slot:activator="{ on, attrs }">-->
          <!--                <v-btn v-bind="attrs" icon text small>-->
          <!--                  <v-icon class="material-icons" color="blue">edit</v-icon>-->
          <!--                </v-btn>-->
          <!--              </template><span>Edit Ad schedule</span></v-tooltip>-->

          <!--              <v-tooltip left><template v-slot:activator="{ on, attrs }">-->
          <!--                <v-btn text icon small v-bind="attrs" v-on="on"-->
          <!--                       @click="deleteScheduleDialog = !deleteScheduleDialog;-->
          <!--                       ad_schedule_id = props.item.id;">-->
          <!--                  <v-icon class="material-icons" color="red">delete</v-icon>-->
          <!--                </v-btn>-->
          <!--              </template><span>Delete Ad Schedule</span></v-tooltip>-->

          <!--            </td>-->
          <!--          </template>-->
          <!--        </v-data-table>-->
        </v-flex>

        <v-dialog v-model="deleteScheduleDialog" scrollable :overlay="false" max-width="450px"
                  transition="dialog-transition"
                  hide-overlay persistent>
          <v-card>

            <v-card-title style="justify-content: space-between !important;">
              <span class="headline">Create AD Schedule</span>
              <v-btn icon @click="clearData()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-title primary-title>
              <span>Are you sure you wish to delete this Ad Schedule ?</span>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat @click="deleteScheduleDialog = false">
                Cancel
              </v-btn>
              <v-btn color="green darken-1" flat :loading="delete_loading" @click="deleteAdSchedule()">Confirm</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="addNewAdScheduleDialog" persistent max-width="500px">
          <v-card>
            <v-form id="ad_schedule"
                    data-vv-scope="storeAdSchedule"
                    ref="ad_schedule"
                    v-model="valid">
              <v-card-title style="justify-content: space-between !important;">
                <span class="headline">Create AD Schedule</span>
                <v-btn icon @click="clearData()">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-layout wrap grid-list-md>
                  <v-flex xs12 sm12 md12>
                    <label>Slot Name & Position: </label>
                    <v-autocomplete
                        v-model="new_ad_schedule.slot_id"
                        :items="slot_details"
                        item-value="id"
                        :item-text="getSlotData"
                        placeholder="Search by Slot & Position"
                        clearable solo flat
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg12>
                    <label>Network Name: </label>
                    <v-autocomplete
                        v-model="new_ad_schedule.network_provider_id"
                        :items="network_provider"
                        placeholder="Search by Network Provider name"
                        item-value="id"
                        item-text="name"
                        v-validate="'required'"
                        clearable solo flat
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg12>
                    <label>Start Time: </label>
                    <div style="padding-bottom: 23px !important;">
                      <flat-pickr
                          class="flatpickerCSS2"
                          v-model="new_ad_schedule.start_time"
                          :config="config"
                          placeholder="Start Time" v-validate="'required'"
                          name="Start time"/>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg12>
                    <label>End Time: </label>
                    <div style="padding-bottom: 23px !important;">
                      <flat-pickr
                          class="flatpickerCSS2"
                          v-model="new_ad_schedule.end_time"
                          :config="config"
                          placeholder="End Time" v-validate="'required'"
                          name="end Time"/>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="color: white" @click="addNewAdScheduleDialog = false">Close</v-btn>
                <v-btn color="primary" style="color: white" @click="storeAdSchedule()"
                       :disabled="(new_ad_schedule.network_provider_id == undefined &&
                     new_ad_schedule.start_time == undefined && new_ad_schedule.end_time == undefined
                     && new_ad_schedule.slot_id == undefined)">Save
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>


        <v-dialog v-model="updateAdNetworkDialog" persistent max-width="500px">
          <v-card>
            <v-form id="ad_network"
                    data-vv-scope="updateAdNetwork"
                    ref="ad_network"
                    v-model="valid">
              <v-card-title style="justify-content: space-between !important;">
                <span class="headline">Update AD Network</span>
                <v-btn icon @click="clearData()">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-layout wrap grid-list-md>
                  <v-flex xs12 sm12 md12>
                    <v-layout row style="display: flex; align-items: center; list-style: none;">
                      <v-flex xs12 md12 lg6>
                        <div style="display: flex; height: 45px;">
                          <v-flex xs6 md6 lg6 class="module_row" style="background-color: #E6E6E8FF">
                            <span>{{"Network Name"}}</span>
                          </v-flex>
                          <v-flex xs6 md6 lg6 class="module_row" style="background-color: #E6E6E8FF">
                            <span>{{"Enable/Disable"}}</span>
                          </v-flex>
                        </div>
                        <li v-for="detail in network_provider" style="display: flex; height: 45px; border: 1px solid #E6E6E8FF">
                          <v-flex xs6 md6 lg6 class="module_row">
                            <span class="module_name">{{detail.name}}</span>
                          </v-flex>

                          <v-flex xs6 md6 lg6 class="module_row">
                            <label class="switch">
                              <input type="checkbox" v-model="detail.is_active" />
                              <span class="slider round"></span>
                            </label>
                          </v-flex>
                        </li>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="color: white" @click="updateAdNetworkDialog = false">Close</v-btn>
                <v-btn color="primary" style="color: white" @click="updateAdNetworkStatus()">Save
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                    :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
          {{ snackbar.message }}
          <v-btn
              text
              dark
              @click="snackbar.display = false"
          >
            <v-icon
                right
                color="white"
            >
              close
            </v-icon>
          </v-btn>
        </v-snackbar>


      </v-layout>
    </v-container>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: "DynamicSchedule",
  components: {
    flatPickr,
  },
  data() {
    return {
      adScheduleLoading: false,
      deleteScheduleDialog: false,
      adData: [],
      ad_schedule_id: "",
      delete_loading: false,
      headers: [
        {
          text: "Slot Name",
          value: "slot_name",
          align: 'left'
        },
        {
          text: "Slot position",
          value: "screen_location",
          align: 'right'
        },
        {
          text: "Network Name",
          value: "network_name",
          align: 'right'
        },
        {
          text: "Is Active",
          value: "is_active",
          align: 'left'
        },
        {
          text: "Start Time",
          value: "start_time",
          align: 'left'
        },
        {
          text: "End Time",
          value: "end_time",
          align: 'left'
        },
        {
          text: "Action",
          value: "action",
          align: 'left'
        }
      ],
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000
      },
      editingRowId: null,
      originalData: {},
      network_provider: [],
      slot_details: [],
      addNewAdScheduleDialog: false,
      new_ad_schedule: {
        slot_id: "",
        network_provider_id: "",
        start_time: "",
        end_time: ""
      },
      config: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
      },
      total_items: 0,
      is_network_active: '',
      updateAdNetworkDialog: false,
      new_data:[],
    }
  },
  methods: {
    isEditingRow(id) {
      return this.editingRowId === id;
    },
    startEdit(id) {
      this.editingRowId = id;

      const itemToEdit = this.adData.find(item => item.id === id);
      if (itemToEdit) {
        this.originalData[id] = {...itemToEdit};
      }
    },
    cancelEdit(id) {
      this.editingRowId = null;
      this.getDynamicScheduleData();
    },
    saveRow(item) {
      this.editAdSchedule(item);
    },
    getDynamicScheduleData() {
      this.adScheduleLoading = true;
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-dynamic-schedules`,
          {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.adScheduleLoading = false;
              this.adData = response.data.data;
            } else {
              this.adScheduleLoading = false;
            }
          }).catch((error) => {
        console.warn(error);
      });
    },
    deleteAdSchedule() {
      this.delete_loading = true;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/delete-ad-schedule`,
          {id: this.ad_schedule_id},
          {headers: this.$headers}).then((response) => {
        if (response.data.status == 1) {
          this.delete_loading = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
          this.deleteScheduleDialog = false;
          this.getDynamicScheduleData();
        } else if (response.data.status == 0) {
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
          this.delete_loading = false;
          this.deleteScheduleDialog = false;
        }
      }).catch((error) => {
        this.delete_loading = false;
        this.deleteScheduleDialog = false;
        console.warn(error);
      });
    },
    getNetworkProvider() {
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-network-provider-data`,
          {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.network_provider = response.data.network_provider;
              this.slot_details = response.data.slot_details;
            }
          }).catch((error) => {
        console.warn(error);
      });
    },
    getSlotData(item) {
      return `${item.slot_name} - ${item.screen_location}`
    },
    clearData() {
      this.new_ad_schedule = [];
      this.addNewAdScheduleDialog = false;
      this.deleteScheduleDialog = false;
      this.updateAdNetworkDialog = false;
    },
    editAdSchedule(data) {
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-ad-schedule`,
          {data},
          {headers: this.$headers}).then((response) => {
        if (response.data.status == 1) {
          this.stopLoading();
          this.editingRowId = null;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
          this.getDynamicScheduleData();
        } else if (response.data.status == 0) {
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
          this.stopLoading();
          this.editingRowId = null;
          this.getDynamicScheduleData();
        }
      }).catch((error) => {
        this.getDynamicScheduleData();
        this.editingRowId = null;
        this.stopLoading();
        console.warn(error);
      });
    },
    storeAdSchedule() {
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/store-ad-schedule`,
          {data: this.new_ad_schedule},
          {headers: this.$headers}).then((response) => {
        if (response.data.status == 1) {
          this.stopLoading();
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
          this.addNewAdScheduleDialog = false;
          this.getDynamicScheduleData();
        } else if (response.data.status == 0) {
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
          this.stopLoading();
          this.addNewAdScheduleDialog = false;
          this.getDynamicScheduleData();
        }
      }).catch((error) => {
        this.addNewAdScheduleDialog = false;
        this.stopLoading();
        this.getDynamicScheduleData();
        console.warn(error);
      });
    },
    updateAdNetworkStatus() {
      this.startLoading();
      this.new_data = [];
      this.network_provider.forEach(element => {
        if (element.is_active == false) {
          this.new_data.push({ id: element.id, is_active: 0 });
        } else if (element.is_active == true)  {
          this.new_data.push({ id: element.id, is_active: 1 });
        }
      });
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-ad-network`, {
        new_data: this.new_data
      }, {headers: this.$headers}).then((response) => {
        if (response.data.status == 1) {
          this.stopLoading();
          this.updateAdNetworkDialog = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
          this.getDynamicScheduleData();
        } else if (response.data.status == 0) {
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
          this.updateAdNetworkDialog = false;
          this.stopLoading();
          this.getDynamicScheduleData();
        }
      }).catch((error) => {
        this.getDynamicScheduleData();
        this.updateAdNetworkDialog = false;
        this.stopLoading();
        console.warn(error);
      });
    },
  },
  mounted() {
    this.getDynamicScheduleData();
    this.getNetworkProvider();
  }
}
</script>

<style>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch input {
  display: none;
}
.module_row{
  display: flex;
  align-items: center;
  align-content: center;
  border-left: 1px solid #f3f3f5;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}
input[type="checkbox"]:checked + input[type="hidden"] + .slider,
input[type="checkbox"]:checked + .slider {
  background-color: #2196F3;
}
input[type="checkbox"]:focus + input[type="hidden"] + .slider,
input[type="checkbox"]:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
input[type="checkbox"]:checked + input[type="hidden"] + .slider:before,
input[type="checkbox"]:checked + .slider:before {
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
</style>
